__turbopack_context__.v({
  "container": "GOM67a_container",
  "title": "GOM67a_title",
});
